import { Link } from "react-router-dom";
import { CalendarDays, BellRing, Pencil, Trash2, MapPin, Mail } from "lucide-react";
import { toast } from "sonner";
import { Checkbox } from "./ui/checkbox";
import { ConfirmDelete } from "./common";
import { fmtDate, isOverdue, relanceMailto } from "../lib/constants";
import { useData } from "../context/DataContext";

const MailButton = ({ rdv, client }) => {
  const cls = "inline-flex items-center gap-1 rounded-md border border-[var(--kc-gold)]/50 bg-[var(--kc-gold)]/10 px-2 py-0.5 text-[11px] font-medium text-[var(--kc-gold-dark)] transition-colors hover:bg-[var(--kc-gold)]/25";
  if (!client?.contact_email) {
    return <button type="button" className={cls} data-testid={`rdv-mail-button-${rdv.id}`} onClick={() => toast.error("Aucune adresse e-mail renseignée pour ce contact", { description: "Ajoutez-la dans la fiche demande." })}><Mail className="h-3 w-3" />Rédiger l'e-mail</button>;
  }
  return <a href={relanceMailto(client)} className={cls} data-testid={`rdv-mail-button-${rdv.id}`} title={`Écrire à ${client.contact_email}`}><Mail className="h-3 w-3" />Rédiger l'e-mail</a>;
};

export const RdvItem = ({ rdv, onEdit, showClient = true, compact = false }) => {
  const { patch, remove, byId } = useData();
  const client = byId[rdv.demande_id];
  const late = !rdv.fait && isOverdue(rdv.date);
  const Icon = rdv.type === "relance" ? BellRing : CalendarDays;
  const toggle = async (v) => { await patch("rdvs", rdv.id, { fait: !!v }); toast.success(v ? "Marqué comme traité" : "Rouvert"); };

  return (
    <div data-testid={`rdv-item-${rdv.id}`} className={`group flex items-start gap-4 rounded-lg border px-4 py-3 transition-colors ${late ? "border-[#B42318]/30 bg-[#B42318]/[0.04]" : "border-[var(--kc-line)] bg-white hover:border-[var(--kc-navy)]/30"}`}>
      <Checkbox checked={rdv.fait} onCheckedChange={toggle} className="mt-1" data-testid={`rdv-done-checkbox-${rdv.id}`} />
      <div className={`mt-0.5 rounded-md p-1.5 ${rdv.type === "relance" ? "bg-[var(--kc-gold)]/15 text-[var(--kc-gold-dark)]" : "bg-[var(--kc-navy)]/10 text-[var(--kc-navy)]"}`}><Icon className="h-4 w-4" /></div>
      <div className="min-w-0 flex-1">
        <p className={`text-sm font-medium ${rdv.fait ? "text-[var(--kc-muted)] line-through" : "text-[var(--kc-navy)]"}`}>{rdv.titre}</p>
        <div className="mt-1 flex flex-wrap items-center gap-x-3 gap-y-1 text-xs text-[var(--kc-muted)]">
          <span className={late ? "font-semibold text-[#B42318]" : ""}>{fmtDate(rdv.date, "EEE d MMM · HH:mm")}{late && " · en retard"}</span>
          {showClient && client && <Link to={`/demandes/${client.id}`} className="font-medium text-[var(--kc-navy)] hover:underline" data-testid={`rdv-client-link-${rdv.id}`}>{client.entreprise}</Link>}
          {!compact && rdv.lieu && <span className="inline-flex items-center gap-1"><MapPin className="h-3 w-3" />{rdv.lieu}</span>}
          {rdv.type === "relance" && !rdv.fait && <MailButton rdv={rdv} client={client} />}
        </div>
        {!compact && rdv.notes && <p className="mt-1.5 text-xs text-[var(--kc-muted)]">{rdv.notes}</p>}
      </div>
      {!compact && (
        <div className="flex gap-1 opacity-60 transition-opacity group-hover:opacity-100">
          <button onClick={() => onEdit?.(rdv)} className="rounded p-1.5 hover:bg-[var(--kc-sand)]" data-testid={`rdv-edit-button-${rdv.id}`}><Pencil className="h-3.5 w-3.5" /></button>
          <ConfirmDelete onConfirm={() => remove("rdvs", rdv.id)} trigger={<button className="rounded p-1.5 hover:bg-[var(--kc-sand)]" data-testid={`rdv-delete-button-${rdv.id}`}><Trash2 className="h-3.5 w-3.5" /></button>} />
        </div>
      )}
    </div>
  );
};
